var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 19,
    fill: "none",
    viewBox: "0 0 17 19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M16.673 19H.327A.32.32 0 0 1 0 18.683V2.85c0-.174.146-.316.327-.316h4.577V.316C4.904.142 5.05 0 5.23 0c.18 0 .327.142.327.316v2.218h5.884V.316c0-.174.146-.316.327-.316s.327.142.327.316v2.218h4.577c.18 0 .327.142.327.316v15.833a.32.32 0 0 1-.327.317m-.327-15.833h-4.25v.95a.32.32 0 0 1-.327.316.32.32 0 0 1-.327-.317v-.949H5.558v.95a.32.32 0 0 1-.327.316.32.32 0 0 1-.327-.317v-.949H.654v2.85h15.692zm0 3.483H.654v11.716h15.692zM5.98 8.902a.34.34 0 0 1 .357-.069c.122.05.201.165.201.293v6.684a.32.32 0 0 1-.326.317.32.32 0 0 1-.327-.317V9.89l-.823.797a.335.335 0 0 1-.462 0 .31.31 0 0 1 0-.448zm2.52-.036zl3.27.01c.18 0 .326.142.325.317a.32.32 0 0 1-.327.316l-2.942-.008V11.4h1.471c1.33 0 2.125.828 2.125 2.217 0 2.184-1.322 2.51-2.11 2.51-1.39 0-2.14-.967-2.14-1.877 0-.175.146-.317.327-.317.18 0 .327.142.327.317 0 .48.403 1.243 1.486 1.243.625 0 1.456-.194 1.456-1.876 0-1.037-.508-1.584-1.47-1.584H8.5a.32.32 0 0 1-.327-.317V9.183c0-.084.035-.165.096-.224a.33.33 0 0 1 .231-.093",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h17v19H0z"
  })))));
};
export default SvgCalendar;